import Swiper from 'swiper';
import { Pagination,Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


document.addEventListener( 'DOMContentLoaded', function() {


    const swiper = new Swiper(".mySwiperBA", {
        modules: [Pagination,Autoplay],

        slidesPerView: 4,
        spaceBetween: 30,
        initialSlide: 0,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            dynamicBullets: true,
        },
        autoplay:false,
        breakpoints: {
            200: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 30,
            },
            980: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1281: {
                slidesPerView: 4,
                spaceBetween: 30,
            },
        },
    });

    if (swiper.autoplay) {
        swiper.autoplay.stop(); // Explicitly stop autoplay on swiper2
    }

});